<template>

<core-content-wrapper :loading="!is.ready || is.refreshing || is.fetching === 'all'">

	<core-filter :loading="is.fetching" :filter="insightName" v-on:refresh="onRefresh">

	</core-filter>

	<core-content-page v-if="is.reset && is.fetching !== 'all'">

		<core-content-page-inner v-show="is.ready" :is-grid="true">

			<com-summary v-if="!$isMobile" :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-context v-if="!$isMobile" :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-game-info v-if="!$isMobile" :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-tabs v-if="!$isMobile" :tabs="tabs" :active="tab" v-on:change="onTabChange" />

			<div class="mobile-tab-select" v-if="$isMobile" v-click-outside="closeMobileTab">
				<div class="mobile-tab-select-button" v-on:click="tabMenuOpen = !tabMenuOpen">
					<span>{{ activeTabText }}</span>
					<i class="fa fa-caret-down"></i>
				</div>
				<transition name="mobile-tab-pop">
					<div class="mobile-tab-select-menu" v-if="tabMenuOpen">
						<div class="mobile-tab-select-option" v-for="t in tabs" :key="t.value" :class="{'is-active': tab === t.value}" v-on:click="onMobileTabSelect(t.value)">{{ t.text }}</div>
					</div>
				</transition>
			</div>

		</core-content-page-inner>

	</core-content-page>

	<core-content-page v-if="is.reset && is.fetching !== 'all'" class="tab-content">

		<core-content-page-inner v-show="is.ready" :is-grid="true" v-if="tab === 'summary'">

			<com-summary :fetching="is.fetching" :your="your" :you="you" :size="6" />

			<com-context :fetching="is.fetching" :your="your" :you="you" :size="6" />

			<com-game-info :fetching="is.fetching" :your="your" :you="you" :size="6" />

		</core-content-page-inner>

		<core-content-page-inner v-show="is.ready" :is-grid="true" v-if="tab === 'plays'">

			<com-plays-overview :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-streaks :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-momentum :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-plays-counts :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-opponents :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-win-rate :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-heatmap :fetching="is.fetching" :your="your" :you="you" :size="6" />

			<com-plays-duration :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-plays-calendar :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-locations :fetching="is.fetching" :your="your" :you="you" :size="2" />

		</core-content-page-inner>

		<core-content-page-inner v-show="is.ready" :is-grid="true" v-if="tab === 'timeline'">

			<com-timeline :fetching="is.fetching" :your="your" :you="you" :size="6" />

		</core-content-page-inner>

		<core-content-page-inner v-show="is.ready" :is-grid="true" v-if="tab === 'peers'">

			<com-peers-overview :fetching="is.fetching" :your="your" :you="you" :size="3" />

			<com-peers-status :fetching="is.fetching" :your="your" :you="you" :size="3" />

			<com-peers-plays :fetching="is.fetching" :your="your" :you="you" :size="6" />

			<com-peers-player-counts :fetching="is.fetching" :your="your" :you="you" :size="3" />

			<com-peers-duration :fetching="is.fetching" :your="your" :you="you" :size="3" />

			<com-peers-heatmap :fetching="is.fetching" :your="your" :you="you" :size="6" />

			<com-peers-experience :fetching="is.fetching" :your="your" :you="you" :size="3" />

			<com-peers-count-rating :fetching="is.fetching" :your="your" :you="you" :size="3" />

			<com-peers-ratings :fetching="is.fetching" :your="your" :you="you" :size="6" />

		</core-content-page-inner>

		<core-content-page-inner v-show="is.ready" :is-grid="true" v-if="tab === 'affinity'">

			<com-affinity-people :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-affinity-mechanics :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-affinity-categories :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-affinity-exploration :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-affinity-win-rate :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-affinity-dna :fetching="is.fetching" :your="your" :you="you" :size="2" />

		</core-content-page-inner>

		<core-content-page-inner v-show="is.ready" :is-grid="true" v-if="tab === 'tracking'">

			<com-tracking-chart :fetching="is.fetching" :your="your" :you="you" :size="3" metric="owners" />

			<com-tracking-chart :fetching="is.fetching" :your="your" :you="you" :size="3" metric="wishlisted" />

			<com-tracking-chart :fetching="is.fetching" :your="your" :you="you" :size="3" metric="totalPlays" />

			<com-tracking-chart :fetching="is.fetching" :your="your" :you="you" :size="3" metric="players" />

			<com-tracking-chart :fetching="is.fetching" :your="your" :you="you" :size="3" metric="avgRating" />

			<com-tracking-chart :fetching="is.fetching" :your="your" :you="you" :size="3" metric="rank" />

		</core-content-page-inner>

	</core-content-page>

</core-content-wrapper>

</template>

<script>

import Section from './common/Section.js'

import comSummary from './game/Summary'
import comContext from './game/Context'
import comGameInfo from './game/GameInfo'
import comTabs from './common/Tabs'
import comHeatmap from './game/Heatmap'
import comPlaysOverview from './game/PlaysOverview'
import comPlaysCalendar from './game/PlaysCalendar'
import comPlaysCounts from './game/PlaysCounts'
import comPlaysDuration from './game/PlaysDuration'
import comOpponents from './game/Opponents'
import comLocations from './game/Locations'
import comStreaks from './game/Streaks'
import comMomentum from './game/Momentum'
import comWinRate from './game/WinRate'
import comTimeline from './game/Timeline'
import comPeersOverview from './game/PeersOverview'
import comPeersRatings from './game/PeersRatings'
import comPeersPlays from './game/PeersPlays'
import comPeersExperience from './game/PeersExperience'
import comPeersHeatmap from './game/PeersHeatmap'
import comPeersCountRating from './game/PeersCountRating'
import comPeersDuration from './game/PeersDuration'
import comPeersPlayerCounts from './game/PeersPlayerCounts'
import comPeersStatus from './game/PeersStatus'
import comTrackingChart from './game/TrackingChart'
import comAffinityPeople from './game/AffinityPeople'
import comAffinityMechanics from './game/AffinityMechanics'
import comAffinityCategories from './game/AffinityCategories'
import comAffinityExploration from './game/AffinityExploration'
import comAffinityWinRate from './game/AffinityWinRate'
import comAffinityDNA from './game/AffinityDNA'

export default {

	mixins: [Section],

	components: {
		'com-summary': comSummary,
		'com-context': comContext,
		'com-game-info': comGameInfo,
		'com-tabs': comTabs,
		'com-heatmap': comHeatmap,
		'com-plays-overview': comPlaysOverview,
		'com-plays-calendar': comPlaysCalendar,
		'com-plays-counts': comPlaysCounts,
		'com-plays-duration': comPlaysDuration,
		'com-opponents': comOpponents,
		'com-locations': comLocations,
		'com-streaks': comStreaks,
		'com-momentum': comMomentum,
		'com-win-rate': comWinRate,
		'com-timeline': comTimeline,
		'com-peers-overview': comPeersOverview,
		'com-peers-ratings': comPeersRatings,
		'com-peers-plays': comPeersPlays,
		'com-peers-experience': comPeersExperience,
		'com-peers-player-counts': comPeersPlayerCounts,
		'com-peers-status': comPeersStatus,
		'com-peers-heatmap': comPeersHeatmap,
		'com-peers-count-rating': comPeersCountRating,
		'com-peers-duration': comPeersDuration,
		'com-tracking-chart': comTrackingChart,
		'com-affinity-people': comAffinityPeople,
		'com-affinity-mechanics': comAffinityMechanics,
		'com-affinity-categories': comAffinityCategories,
		'com-affinity-exploration': comAffinityExploration,
		'com-affinity-win-rate': comAffinityWinRate,
		'com-affinity-dna': comAffinityDNA
	},

	directives: {
		clickOutside: require('v-click-outside').directive
	},

	data: function() {

		return {

			insightName: 'game',
			tab: (window.innerWidth <= 767) ? 'summary' : 'plays',
			tabMenuOpen: false

		}

	},

	computed: {

		gameData: function() {

			return this.$store.getters['page/insights/game/game']

		},

		gameName: function() {

			return this.gameData.name || ''

		},

		tabs: function() {

			var prefix = (this.your === 'your') ? 'Your' : 'User'

			var list = []

			if (this.$isMobile) list.push({ value: 'summary', text: 'Summary' })

			list.push({ value: 'plays', text: prefix + ' Plays' })
			list.push({ value: 'timeline', text: prefix + ' Timeline' })
			list.push({ value: 'affinity', text: prefix + ' Affinity' })
			list.push({ value: 'peers', text: 'Peers' })
			list.push({ value: 'tracking', text: 'Game Tracking' })

			return list

		},

		activeTabText: function() {

			var active = this.$_.find(this.tabs, { value: this.tab })
			return active ? active.text : ''

		}

	},

	methods: {

		onTabChange: function(value) {

			this.tab = value

		},

		onMobileTabSelect: function(value) {

			this.tab = value
			this.tabMenuOpen = false

		},

		closeMobileTab: function() {

			this.tabMenuOpen = false

		},

		fetch: function(type, name) {

			type = type || this.$route.params.type
			name = name || this.$route.params.name

			this.is.fetching = 'all'
			this.$store.commit('page/insights/' + this.insightName + '/reset')

			this.$store.dispatch('api/insights/' + type, {
				name: name,
				index: this.$route.params.index || '',
				section: this.insightName,
				insight: this.insightFetch,
				id: parseInt(this.$route.params.game) || 0
			}).then(function() {

				this.currentFilter = this.$_.clone(this.$store.getters['filter/insights/' + this.insightName])
				this.is.ready = true
				this.is.fetching = false
				this.is.refreshing = false

				if(this.afterLoad) this.afterLoad()

				this.$pubsub.$emit('ready')

			}.bind(this))

		},

		afterLoad: function() {

			if (this.gameName) {

				document.title = this.gameName.toLowerCase() + ' | ' + document.title

			}

		}

	},

	beforeRouteUpdate: function(to, from, next) {

		if (to.params.game !== from.params.game || to.params.name !== from.params.name || to.params.type !== from.params.type) {

			this.reset(to).then(function() {

				this.is.filterChanged = true

				next()

				this.fetch()

			}.bind(this))

		} else {

			next()

		}

		if (to.fullPath !== from.fullPath) {

			// eslint-disable-next-line
			ga('set', 'page', to.fullPath)

			// eslint-disable-next-line
			ga('send', 'pageview')

		}

	}

}

</script>

<style scoped>

.tab-content {
	padding-top: 40px!important;
}

.is-mobile .tab-content {
	padding-top: 0px!important;
}

.is-desktop .tab-content:before {
	position: absolute;
	content: '';
	display: block;
	left: -40px;
	right: -40px;
	top: 0px;
	bottom: -40px;
	background-color: #fff;
}

.is-desktop .tab-content >>> .insights-item:hover:before {
	background-color: #edf8ff;
}

.mobile-tab-select {
	grid-column: span 6;
	position: relative;
	margin-bottom: 20px;
}

.mobile-tab-select-button {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 14px;
	background: #4881bb;
	border: none;
	border-radius: 4px;
	font-size: 15px;
	font-weight: 500;
	color: #fff;
	cursor: pointer;
}

.mobile-tab-select-button .fa {
	font-size: 12px;
	color: rgba(255, 255, 255, 0.7);
}

.mobile-tab-select-menu {
	position: absolute;
	top: calc(100% + 4px);
	left: 0;
	right: 0;
	background: #1a3a4a;
	border-radius: 6px;
	padding: 4px 0;
	z-index: 500000000;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

.mobile-tab-select-option {
	padding: 10px 14px;
	font-size: 14px;
	font-weight: 400;
	color: rgba(255, 255, 255, 0.85);
	cursor: pointer;
}

.mobile-tab-select-option.is-active {
	font-weight: 600;
	color: #fff;
}

.mobile-tab-pop-enter-active {
	transition: opacity 100ms ease, transform 100ms ease;
}

.mobile-tab-pop-leave-active {
	transition: opacity 80ms ease;
}

.mobile-tab-pop-enter {
	opacity: 0;
	transform: translateY(-4px);
}

.mobile-tab-pop-leave-to {
	opacity: 0;
}

.is-mobile .tab-content >>> .insights-item-content {
	min-height: 1px;
}

</style>
